import { z } from "zod"
import { StudentSchema } from "./User"

export const DailyStatusSchema = z.object({
    student: z.string(),
    test: z.number(),
    time: z.number(),
    status: z.number(),
    status_color: z.string()
})

export const FolderSchema = z.object({
    id: z.number(),
    name: z.string(),
    students: z.array(StudentSchema)
})


export const FolderServerResponseSchema = z.array(FolderSchema);
export const DailyStatusServerResponse = z.array(DailyStatusSchema);

export type FolderType = z.infer<typeof FolderSchema>
export type DailyStatusType = z.infer<typeof DailyStatusSchema>
export type SelectedFolderType = {
    index: number;
    folder: FolderType;
    element: HTMLDivElement | null;
}